import { FormElement } from 'ui/form-element/form-element';

import { ChangeEvent, forwardEnterToClick } from 'cadenza/utils/event-util';

import './switch.css';

export interface SwitchOptions {
  name?: string;
  checked?: boolean;
  disabled?: boolean;
}

export class Switch extends FormElement<boolean> {

  /**
   * @param [options] - Options
   * @param [options.checked] - Whether the switch is initially checked
   * @param [options.disabled] - Whether the switch is initially disabled
   */
  constructor ({ name, checked, disabled }: SwitchOptions = {}) {
    super({
      name,
      defaultValue: false,
      disabled
    });
    this.defaultValue = checked ?? (this.getAttribute('aria-checked') === 'true');

    this.addEventListener('keydown', forwardEnterToClick);
    this.addEventListener('click', (event) => {
      if (!this.disabled) {
        event.preventDefault(); // Prevent another click on the <label>.
        this.checked = !this.checked;
        this.dispatchEvent(new ChangeEvent('change', {
          detail: { checked: this.checked }
        }));
      }
    });
  }

  override connectedCallback () {
    super.connectedCallback();
    this.classList.add('d-switch');
    this.setAttribute('role', 'switch');
    this.tabIndex = 0;
  }

  protected override applyValue (value: boolean) {
    this.setAttribute('aria-checked', String(value));
  }

  set checked (value) {
    this.value = value;
  }

  get checked () {
    return this.value;
  }

  set defaultChecked (value) {
    this.defaultValue = value;
  }

  get defaultChecked () {
    return this.defaultValue;
  }

}

customElements.define('d-switch', Switch);
